const features = [
  {
    icon: "ri-lock-2-line",
    title: "End-to-End Encryption",
    desc: "All data transmitted through our apps is protected with industry-leading AES-256 encryption, ensuring your information stays private at all times.",
    color: "bg-slate-900 text-white",
    iconColor: "text-cyan-400",
  },
  {
    icon: "ri-smartphone-line",
    title: "Native iOS Experience",
    desc: "Designed to seamlessly integrate with iOS, our apps follow Apple&apos;s Human Interface Guidelines for a fluid, intuitive experience on every device.",
    color: "bg-cyan-500 text-white",
    iconColor: "text-white",
  },
  {
    icon: "ri-eye-off-line",
    title: "Zero Data Collection",
    desc: "We operate on a strict no-log policy. Your usage data, connection history, and personal information are never collected, stored, or sold.",
    color: "bg-white text-gray-900",
    iconColor: "text-cyan-500",
  },
  {
    icon: "ri-cpu-line",
    title: "Low Resource Usage",
    desc: "Engineered for efficiency, our apps consume minimal CPU and battery resources, running silently in the background without impacting performance.",
    color: "bg-white text-gray-900",
    iconColor: "text-cyan-500",
  },
  {
    icon: "ri-refresh-line",
    title: "Automatic Updates",
    desc: "Our products receive continuous improvements, security patches, and new features through the App Store with no manual action required.",
    color: "bg-teal-500 text-white",
    iconColor: "text-white",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Dedicated Support",
    desc: "Our expert support team is available to help with any questions or issues, ensuring you always get the most from your NURA DOO applications.",
    color: "bg-slate-900 text-white",
    iconColor: "text-cyan-400",
  },
];

const techBadges = [
  "Swift 5", "SwiftUI", "Core Data", "CloudKit",
  "Network Extension", "CryptoKit", "Combine", "WidgetKit",
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-20">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-8 bg-cyan-400" />
            <span className="text-cyan-500 text-xs uppercase tracking-[0.25em] font-medium">Features</span>
            <span className="h-px w-8 bg-cyan-400" />
          </div>
          <h2
            className="text-4xl md:text-5xl font-light text-gray-900 leading-tight"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Why choose <span className="font-semibold">NURA DOO?</span>
          </h2>
          <p className="text-gray-500 mt-4 max-w-xl text-base leading-relaxed">
            Every feature is thoughtfully designed to give you complete control over your mobile security and performance.
          </p>
        </div>

        {/* Feature cards grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-20">
          {features.map((f) => (
            <div
              key={f.title}
              className={`rounded-2xl p-7 ${f.color} border border-gray-100 transition-transform duration-200 hover:-translate-y-1`}
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-xl mb-5 ${
                f.color.includes("white") ? "bg-cyan-50" : "bg-white/10"
              }`}>
                <i className={`${f.icon} text-xl ${f.iconColor}`} />
              </div>
              <h3
                className="text-base font-semibold mb-3"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                {f.title}
              </h3>
              <p className={`text-sm leading-relaxed ${f.color.includes("white") ? "text-gray-500" : "opacity-75"}`}>
                {f.title === "Native iOS Experience"
                  ? "Designed to seamlessly integrate with iOS, our apps follow Apple's Human Interface Guidelines for a fluid, intuitive experience on every device."
                  : f.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Tech stack */}
        <div className="rounded-2xl bg-gray-50 border border-gray-100 p-10 flex flex-col md:flex-row gap-8 items-center">
          <div className="md:w-72 flex-shrink-0">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-6 bg-cyan-400" />
              <span className="text-cyan-500 text-xs uppercase tracking-[0.2em] font-medium">Technology</span>
            </div>
            <h3
              className="text-2xl font-semibold text-gray-900"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Built with the latest Apple technologies
            </h3>
          </div>
          <div className="flex flex-wrap gap-3">
            {techBadges.map((badge) => (
              <span
                key={badge}
                className="px-4 py-2 rounded-full bg-white border border-gray-200 text-gray-700 text-sm font-medium"
              >
                {badge}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
